import {
  AssetDataLocationObject,
  ContextDataLocationObject,
  InputDataLocationObject,
  PromptDataLocationObject,
  TaskDataLocationObject,
} from "common/flowmaster/types/data_location";
import {TaskArgument} from "common/flowmaster/types/task_config";

export function getErrorStatusForArgValue(
  argValue: TaskArgument | undefined,
): boolean {
  if (!argValue) {
    return false;
  }

  const value = argValue.value;
  if (!value) {
    return false;
  }
  if (typeof value === "number" || !("source_type" in value)) {
    return false;
  }

  const source_type = value.source_type;
  if (
    typeof source_type !== "string" ||
    !["context", "input", "prompt", "task", "asset"].includes(value.source_type)
  ) {
    return false;
  }

  if (value.source_type === "asset") {
    return getErrorStatusForAssetDataLocation(value as AssetDataLocationObject);
  }

  return (
    (value as
      | ContextDataLocationObject
      | InputDataLocationObject
      | PromptDataLocationObject
      | TaskDataLocationObject).key === undefined
  );
}

function getErrorStatusForAssetDataLocation(
  value: AssetDataLocationObject,
): boolean {
  const key = value.key;
  if (key === undefined) {
    return true;
  }

  const assetLocation = value.value;
  if (assetLocation === undefined) {
    return true;
  }

  return false;
}
